import { useCallback } from 'react';
import { useGetSendEmailSelector } from './useGetSendEmailSelector';

export const useGetSubjectLineSelector = () => {
  const getSendEmail = useGetSendEmailSelector();
  return useCallback((id: string) => getSendEmail(id)?.subjectLine, [getSendEmail]);
};
